"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryUserUid = exports.arbitraryNonAnonymousUserUid = exports.arbitraryEnterpriseUid = exports.arbitraryOrganizationUid = void 0;
const tslib_1 = require("tslib");
const constants_1 = require("@buildwithflux/constants");
const fast_check_1 = tslib_1.__importDefault(require("fast-check"));
/**
 * An arbitrary organization UID
 */
exports.arbitraryOrganizationUid = fast_check_1.default
    .uuid()
    .map((uid) => `org_${uid}`);
/**
 * An arbitrary enterprise UID
 */
exports.arbitraryEnterpriseUid = fast_check_1.default.uuid().map((uid) => `ent_${uid}`);
/**
 * A user ID can be one of two values: either the anonymous uid, or any other uid.
 */
exports.arbitraryNonAnonymousUserUid = fast_check_1.default.uuid();
exports.arbitraryUserUid = fast_check_1.default.oneof(fast_check_1.default.constant(constants_1.ANON_ROLE_UID), exports.arbitraryNonAnonymousUserUid);
//# sourceMappingURL=identifier.js.map